import { useEffect, useRef } from 'react';
import { Query } from '@/utils/react-query/Queries';
import useAchievementStore from '@/data/store/useAchievementStore';
import { MILESTONE_PRESENTATION } from '@/config/milestones';

// Compatibility name for existing badge replay callers. Both automatic
// batches and replay now use the app-wide nonmodal achievement queue.
const MilestoneCelebrationModal = ({
    visible, items = [], onDismiss, onViewAchievements, reducedMotion,
    mode = 'auto', testID = 'milestone-celebration',
    dismissTestID = 'milestone-celebration-continue', viewAchievementsTestID = 'milestone-celebration-view-achievements',
}) => {
    const { data: user } = Query.people.loggedInUser();
    const enqueue = useAchievementStore(state => state.enqueue);
    const remove = useAchievementStore(state => state.remove);
    const callbacks = useRef({ onDismiss, onViewAchievements });
    callbacks.current = { onDismiss, onViewAchievements };
    const scope = `${user?.accountID}:${user?.organizationID}`;
    const signature = items.map(item => item.receiptID ?? item.awardID ?? `${item.milestoneID}:${item.threshold}`).join(',');
    useEffect(() => {
        if (!visible || !signature || !user?.accountID || !user?.organizationID) return;
        const id = `${mode}:${scope}:${signature}`;
        const single = items.length === 1 ? items[0] : null;
        enqueue({
            id, scope, items, reducedMotion, testID, dismissTestID, actionTestID: viewAchievementsTestID,
            title: single?.title || MILESTONE_PRESENTATION.defaultTitle,
            message: single ? [single.name, single.message].filter(Boolean).join('\n') : `${items.length} milestones reached`,
            duration: Math.max(6500, items.length * 2500),
            onDismiss: () => callbacks.current.onDismiss?.(),
            onAction: onViewAchievements ? () => callbacks.current.onViewAchievements?.() : undefined,
        });
        return () => remove(id);
    }, [visible, signature, scope, mode, enqueue, remove]);
    return null;
};

export default MilestoneCelebrationModal;
